import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Calendar, Check, Loader2, Link2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function GoogleCalendarConnect() {
  const [busy, setBusy] = useState(false);
  const { data, refetch } = useQuery({ queryKey: ["gcal-status"], queryFn: () => api.get("/google/calendar/status").then((r) => r.data) });

  useEffect(() => {
    const p = new URLSearchParams(window.location.search).get("gcal");
    if (p === "connected") { toast.success("Google Calendar connected"); refetch(); window.history.replaceState({}, "", window.location.pathname); }
    else if (p === "error") { toast.error("We couldn't connect Google Calendar. Please try again."); window.history.replaceState({}, "", window.location.pathname); }
  }, [refetch]);

  const connect = async () => {
    try { setBusy(true); const { data } = await api.get("/google/calendar/connect"); window.location.href = data.url; }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Google Calendar not configured"); setBusy(false); }
  };
  const disconnect = async () => { await api.post("/google/calendar/disconnect"); toast.success("Disconnected"); refetch(); };

  return (
    <div className="eyw-card p-6" data-testid="gcal-connect">
      <div className="flex items-start gap-4">
        <span className="grid place-items-center h-12 w-12 rounded-xl bg-[#144F75]/8 text-[#144F75] shrink-0"><Calendar size={22} /></span>
        <div className="flex-1">
          <h3 className="font-serif text-xl text-[#1A242B]">Google Calendar</h3>
          <p className="text-sm text-[#4A5D6B] mt-1">2-way sync — new bookings appear on your calendar, and your calendar's busy times help protect your availability.</p>
          {data?.connected ? (
            <div className="mt-4 flex items-center gap-3 flex-wrap">
              <span className="inline-flex items-center gap-1.5 text-sm text-[#5C8A72] font-medium" data-testid="gcal-connected"><Check size={16} /> Connected{data.email ? ` · ${data.email}` : ""}</span>
              <button onClick={disconnect} data-testid="gcal-disconnect" className="text-sm text-[#B45151] hover:underline">Disconnect</button>
            </div>
          ) : (
            <button onClick={connect} disabled={busy} data-testid="gcal-connect-btn" className="eyw-btn !py-2 text-sm mt-4 disabled:opacity-60">
              {busy ? <Loader2 size={16} className="animate-spin" /> : <Link2 size={16} />} Connect Google Calendar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
